import CryptoJS from 'crypto-js';

// Development mode uses a simple key for testing
const DEV_KEY = 'dev-key';

// Production mode uses environment variables
const BACKEND_PUBLIC_KEY = process.env.REACT_APP_NEXT_PUBLIC_BACKEND_PUBLIC_KEY || DEV_KEY;
const FRONTEND_PUBLIC_KEY = process.env.REACT_APP_NEXT_PUBLIC_FRONTEND_PUBLIC_KEY || DEV_KEY;
const isProduction = process.env.REACT_APP_NODE_ENV === 'production';

/**
 * Encrypts requests to the backend
 * In production: Uses the backend's public key
 * In development: Uses a simple key for testing
 */
export const encryptRequest = (data) => {
    try {
        if (!isProduction) {
            return JSON.stringify(data);
        }

        return CryptoJS.AES.encrypt(
            JSON.stringify(data),
            BACKEND_PUBLIC_KEY
        ).toString();
    } catch (error) {
        console.error('Encryption error:', error);
        throw new Error('Failed to encrypt request');
    }
};

/**
 * Decrypts responses from the backend
 * In production: Uses the backend's public key
 * In development: Uses a simple key for testing
 */
export const decryptResponse = (encryptedData) => {
    try {
        if (!isProduction) {
            return typeof encryptedData === 'string' ? JSON.parse(encryptedData) : encryptedData;
        }
        const decrypted = CryptoJS.AES.decrypt(encryptedData, BACKEND_PUBLIC_KEY);
        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedString);
    } catch (error) {
        console.error('Decryption error:', error);
        throw new Error('Failed to decrypt response');
    }
};

